module.exports = __webpack_public_path__ + "img/Documents.0d226f61.svg";